import { useState } from 'react';
import { useDossier, useDossiers } from '../../hooks/queries/useDossiers';
import { DossierPickerPanel } from '../dossiers/DossierPickerPanel';

interface Props {
  selectedId: string | null;
  onSelect: (id: string) => void;
  required?: boolean;
  onClear?: () => void;
  startOpen?: boolean;
}

export function DossierPickStep({ selectedId, onSelect, required = true, onClear, startOpen }: Props) {
  const { data: dossiers = [] } = useDossiers({});
  const { data: selected } = useDossier(selectedId ?? undefined);
  const [picking, setPicking] = useState(startOpen || !selectedId);

  if (!picking) {
    return (
      <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-neutral-200">
        <div className="min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">
            Dossier
          </p>
          <p className="text-sm font-medium text-cime-text-primary truncate">
            {selected?.title ?? (selectedId ? '…' : 'Aucun dossier')}
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {!required && selectedId && onClear ? (
            <button
              type="button"
              onClick={onClear}
              className="text-xs text-neutral-400 hover:text-neutral-700"
            >
              Retirer
            </button>
          ) : null}
          <button
            type="button"
            onClick={() => setPicking(true)}
            className="text-sm text-cime-primary hover:underline"
          >
            Changer
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="border-b border-neutral-200">
      {!required ? (
        <button
          type="button"
          onClick={() => {
            onClear?.();
            setPicking(false);
          }}
          className="w-full px-5 py-2 text-left text-sm text-neutral-500 hover:bg-neutral-50"
        >
          Continuer sans dossier
        </button>
      ) : null}
      <DossierPickerPanel
        dossiers={dossiers}
        onPick={(id) => {
          onSelect(id);
          setPicking(false);
        }}
      />
    </div>
  );
}
